import { createClient } from '@sanity/client';

// Extend the SanityClient type to include the properly typed fetch method
declare module '@sanity/client' {
  interface SanityClient {
    fetch<T>(query: string, params?: Record<string, any>): Promise<T>;
  }
}

const sanityClient = createClient({
  projectId: 'bbk8neq3',
  dataset: 'glenullingac',
  useCdn: false, // must be false to use token
  apiVersion: '2023-01-01',
  token: 'sk9tyoef729YilQzYkFGOY1Kkd3b7h9kEo8F2MPjAdr05jYGlLRzvoreHUqwaSIE3CjfK8ATszDZkh9m1D72eIkJnuC2a25n6LpjaahfZjMN2nemGK3g1DifMuygvPHNIry0vWgOpjqwT5J0iUA8OdXrxrfDVWiivMQc8nO7WIA2L5NHs20k', // <-- Add your token here
});

export default sanityClient;
